// extracted by mini-css-extract-plugin
export default {"control":"toggle-icon_control__25h8V","knob":"toggle-icon_knob__1CBeM","loadingIcon":"toggle-icon_loadingIcon__3qGvh","checked":"toggle-icon_checked__28-7P"};